module.exports = __webpack_public_path__ + "static/media/up_arrow.e58f2000.svg";